/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CustomerHatchery } from '../../models/customer-hatchery';

export interface FindByCustomerHatcheryId_1$Params {
  customerId: number;
  hatcheryId: number;
}

export function findByCustomerHatcheryId_1(http: HttpClient, rootUrl: string, params: FindByCustomerHatcheryId_1$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomerHatchery>> {
  const rb = new RequestBuilder(rootUrl, findByCustomerHatcheryId_1.PATH, 'get');
  if (params) {
    rb.path('customerId', params.customerId, {});
    rb.path('hatcheryId', params.hatcheryId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<CustomerHatchery>;
    })
  );
}

findByCustomerHatcheryId_1.PATH = '/api/customer/hatchery/{customerId}/hatchery/{hatcheryId}';
